module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "grid form-input"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "col input"
  }, [_c('input', {
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66400748"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormInput.vue
// module id = 587
// module chunks = 0